import styled, { css } from 'styled-components';

const backgroundYellow =
  'linear-gradient(220deg,rgba(255, 151, 0, 0) 3.21%,rgba(255, 151, 0, 0.4) 96.79%)';

const backgroundOrange =
  'linear-gradient(220deg, rgba(242, 91, 25, 0.00) 3.21%, rgba(242, 91, 25, 0.40) 96.79%)';

const backgroundRed =
  'linear-gradient(220deg, rgba(244, 22, 22, 0.00) 3.21%, rgba(244, 22, 22, 0.40) 96.79%)';

export const Gruop = styled.div`
  width: 100%;
  position: relative;
`;

export const Container = styled.div`
  width: 100%;
  position: relative;
  border-radius: 32px;
  z-index: 0;

  /* &::before {
    width: calc(12px * 12);
    height: calc(16px * 12);
    position: absolute;
    content: '';
    right: -20px;
    z-index: -2;

    background-image: url(${({ $before }) => $before});
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;

    @media ${({ theme }) => theme.devices.mobile} {
      width: calc(12px * 16);
      height: calc(12px * 16);
      top: -20px;
      right: -40px;
    }
  } */

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 32px;
    padding: 2px;
    background: ${backgroundYellow};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;

    ${({ $type }) =>
      $type === 2 &&
      css`
        background: ${backgroundOrange};
      `}

    ${({ $type }) =>
      $type === 3 &&
      css`
        background: ${backgroundRed};
      `}
  }
`;

export const Background = styled.div`
  width: 100%;
  /* height: 200px; */
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 32px;
  padding: 32px 48px;

  background-image: url(${({ $glass }) => $glass});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  @media ${({ theme }) => theme.devices.mobile} {
    padding: 24px 44px;
  }
`;

export const Icon = styled.div`
  position: absolute;
  width: 100%;
  max-width: 112px;
  top: -4px;
  right: -20px;

  ${({ $type }) =>
    $type === 2 &&
    css`
      max-width: 120px;
      top: -8px;
      right: -24px;
    `}

  ${({ $type }) =>
    $type === 3 &&
    css`
      max-width: 140px;
      top: -32px;
      right: -32px;
    `}

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${({ $icon }) => $icon});
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 0.5;
    filter: blur(8px);
    z-index: 1;
  }

  img {
    position: relative;
    z-index: 2;
    display: block;
    width: 100%;
    height: 100%;
  }
`;

export const GroupInfos = styled.div`
  width: max-content;
  max-width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;

  img {
    width: 100%;
    max-width: 68px;
    position: relative;

    @media ${({ theme }) => theme.devices.mobile} {
      max-width: 60px;
    }

    ${({ $type }) =>
      $type === 2 &&
      css`
        max-width: 90px;

        @media ${({ theme }) => theme.devices.mobile} {
          max-width: 76px;
        }
      `}

    ${({ $type }) =>
      $type === 3 &&
      css`
        max-width: 100px;

        @media ${({ theme }) => theme.devices.mobile} {
          max-width: 90px;
        }
      `}
  }
`;

export const Name = styled.section`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;

  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};

  h3 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    font-size: 28px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 22px;
    }
  }

  h4 {
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 300;
    text-transform: uppercase;
    font-size: 60px;
    margin-bottom: -8px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 40px;
    }
  }

  h2 {
    font-size: 52px;
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    margin-bottom: -10px;

    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 40px;
    }
  }
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 20px;
  padding: 16px;
  border-radius: 0 0 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: space-between; */
  gap: 28px;
`;

export const Ul = styled.ul`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  list-style: none;
  padding: 0 20px;
  gap: 20px;

  li {
    width: fit-content;
    text-align: center;
    position: relative;
    font-size: 16px;
    font-weight: 300;

    &::before {
      content: '';
      position: absolute;
      /* top: 4px; */
      transform: translateY(100%) translateX(-180%);

      width: 6px;
      height: 6px;
      border-radius: 100%;
      background-color: ${({ theme }) => theme.colors.grey.white};
    }

    b {
      font-weight: 700;
    }
  }
`;

export const GroupPrice = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  .line {
    height: 50px;
    min-width: 1px;
    background-color: ${({ theme }) => theme.colors.grey.white};
  }
`;

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h4 {
    width: 100%;
    text-transform: uppercase;
    font-size: 12px;
    text-align: center;
    border-radius: 8px 8px 0 0;
    padding: 2px;
    font-weight: 400;
    background-color: ${({ theme }) => theme.colors.grey.white};
    color: ${({ theme }) => theme.colors.grey.black};
  }

  h2 {
    font-family: 'Anton', sans-serif;
    font-size: 32px;
    font-weight: 300;
    text-align: center;

    span {
      font-family: 'Anton', sans-serif;
      margin-left: 4px;
    }
  }

  span {
    /* font-family: 'Anton', sans-serif; */
    margin-top: 4px;
    font-size: 10px;
    text-align: center;
    font-weight: 400;
  }
`;

export const Signature = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h2 {
    font-size: 52px;
    font-family: 'Anton', sans-serif;
    margin-bottom: -16px;
  }

  span {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 20px;
  }
`;

export const GroupButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  margin-top: 4px;

  .info {
    width: 100%;
    border: 0;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.grey.white};

    span {
      font-size: 12px;
      font-weight: 400;
    }

    &:hover {
      transition: 0.7s;
      text-decoration: underline;
    }
  }

  .buy {
    width: 100%;
    position: relative;
    padding: 16px 0px;
    border-radius: 32px;
    border: 0;
    background: rgba(255, 153, 0, 0.4);
    z-index: 0;

    ${({ $type }) =>
      $type === 2 &&
      css`
        background: rgba(242, 91, 25, 0.4);
      `}

    ${({ $type }) =>
      $type === 3 &&
      css`
        background: rgba(244, 22, 22, 0.4);
      `}

    h2 {
      /* font-family: 'Bebas Neue', sans-serif; */
      text-transform: uppercase;
      font-size: 22px;
      font-weight: 300;
      color: ${({ theme }) => theme.colors.grey.white};
    }

    &:hover {
      transition: 0.7s;
      opacity: 0.5;
    }

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: 32px;
      padding: 2px;
      background: ${backgroundYellow};
      -webkit-mask: linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      z-index: -1;

      ${({ $type }) =>
        $type === 2 &&
        css`
          background: ${backgroundOrange};
        `}

      ${({ $type }) =>
        $type === 3 &&
        css`
          background: ${backgroundRed};
        `}
    }
  }
`;
